import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import ConectarWhatsapp from './pages/ConectarWhatsapp';
import LandingSeguroAuto from './pages/LandingSeguroAuto';

// Admin imports
import ProtectedRoute from './components/admin/ProtectedRoute';
import Login from './pages/admin/Login';
import AdminLayout from './pages/admin/AdminLayout';
import Dashboard from './pages/admin/Dashboard';
import Connection from './pages/admin/Connection';
import Messages from './pages/admin/Messages';
import Analytics from './pages/admin/Analytics';
import Settings from './pages/admin/Settings';

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<Navigate to="/seguro-auto" replace />} />
            <Route path="/seguro-auto" element={<LandingSeguroAuto />} />
            <Route path="/conectar-whatsapp" element={<ConectarWhatsapp />} />

            {/* Admin routes */}
            <Route path="/admin/login" element={<Login />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="connection" element={<Connection />} />
              <Route path="messages" element={<Messages />} />
              <Route path="analytics" element={<Analytics />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
